import type { BreadcrumbList, WithContext } from 'schema-dts';

export function getBreadcrumbSchema(
	title: string,
	category: string | null | undefined,
	categoryPath: string | null,
	appUrl: string
): WithContext<BreadcrumbList> {
	return {
		'@context': 'https://schema.org',
		'@type': 'BreadcrumbList',
		itemListElement: [
			{ name: 'Startseite', item: appUrl },
			categoryPath ? { name: category ?? undefined, item: `${appUrl}${categoryPath}` } : undefined,
			{ name: title },
		]
			.filter((element) => !!element)
			.map((element, position) => {
				return {
					'@type': 'ListItem',
					position: position + 1,
					...element,
				};
			}),
	};
}
